import type { Chain } from "@suse-o11y/chain";
import type { Defaultable } from "@suse-o11y/defaultable";
import type { Functor } from "@suse-o11y/functor";
import { Matchable } from "@suse-o11y/matchable";

class Granted<TValue> extends Matchable<"granted"> implements Functor<TValue>, Chain<TValue>, Defaultable<TValue> {
	protected readonly __name = "granted" as const;

	public constructor(public readonly value: TValue) {
		super();
	}

	public isGranted(): this is Granted<TValue> {
		return true;
	}

	public isDenied(): false {
		return false;
	}

	public getOrElse(): TValue {
		return this.value;
	}

	public transform<TNextValue>(fn: (value: TValue) => TNextValue): Granted<TNextValue> {
		return new Granted(fn(this.value));
	}

	public chain<TNextValue extends Chain<unknown>>(fn: (value: TValue) => TNextValue): TNextValue {
		return fn(this.value);
	}
}

export { Granted };
